<template>
    <v-container class="my-2" >

    
    
    
    <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl" > Serviços</h1>
    <br  >
    <NovaFuncaoDialog :acaoEditar='false' @recarregarLista="carregar"/>
        <br  >
    <v-divider></v-divider>
    <br>
    <v-list>
        
        <v-layout row justify-center class="mx-2" >

            <v-flex x12 sm12 md9 lg8 >

            <v-list-item v-for="item in items" dark class="indigo darken-5 mb-2 rounded-tr-xl"
                    :key="item.title" >
                    <v-list-item-icon >
                        <v-icon size="80" >fa fa-address-book</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content >
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>
                        
                        <v-list-item-title v-text=" `R$ ${(item.preco)}`"> </v-list-item-title>
                        <v-list-item-title v-text=" `Tempo: ${(item.tempo)}`"> </v-list-item-title>
                    
                    </v-list-item-content>
                    
                    <NovaFuncaoDialog :acaoEditar='true' @recarregarLista="carregar" :funcaoPassada="item" />
                    <v-btn class="red" dark small @click="deletar(item)" > <v-icon small>fa fa-trash</v-icon> </v-btn>
                    
                    <v-list-item-avatar>
                   <!-- <v-img :src="item.avatar"></v-img> -->
                    </v-list-item-avatar>
                </v-list-item>



            </v-flex>
        
      
      </v-layout>
    </v-list>    
    </v-container>
</template>

<script>
import NovaFuncaoDialog from './Components/NovaFuncaoDialog'
import firebase from "firebase"



    export default {
        components: {
            NovaFuncaoDialog
        },
        
        data(){
            return {
            dbRef: firebase.firestore().collection('funcoes'),
                
                items: [],
                   
                
            }
        },
        created() {
        /*this.dbRef.onSnapshot(res => {
        //const changes = res.docChanges();
        //pega o ID também
        //this.items = [];
        this.items = [];
        
        res.forEach(doc => {
            
            console.log('adicionado item')
            console.log(doc.data())
            this.items.push(doc.data())
        });
        
      });*/
        this.carregar()
      
        },
        methods: {
            carregar(){
                this.items = []
                this.dbRef.get().then( (snap) => {
                    snap.forEach((doc) => {
                        this.items.push({...doc.data()})
                    } );
                }  );
            },

            deletar(item){
                if(confirm("Deseja apagar mesmo?")){
                    this.dbRef.doc(item.id).delete().then(() =>{
                    console.log("Apagado!");
                    this.$toasted.global.defaultSuccess("Apagado com sucesso!");
                    /*var index = this.items.indexOf(item);
                    if (index > -1) {
                        this.items.splice(index, 1);
                    }*/
                    this.carregar()
                });
                }
                
            }
        }
        
    }
</script>

<style  scoped>
  
</style>